export enum Locales {
    En = 'EN',
    Pl = 'PL',
}

export interface Locale {
    key: Locales;
    name: string;
}